module.exports = __webpack_public_path__ + "img/nycplus.7bd0c64b.jpg";